import { render, staticRenderFns } from "./ValuationResultChart.vue?vue&type=template&id=2d0a2945&"
import script from "./ValuationResultChart.vue?vue&type=script&lang=js&"
export * from "./ValuationResultChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports